import { Coach, coachPortrait } from "../Comments/coach";
import styles from "./CoachButton.module.css";

type CoachButtonProps = {
  children: React.ReactNode;
  coaches: Coach[];
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  className?: string;
  variant?: "onDark";
};

export const CoachButton = ({ children, coaches, onClick, type = "button", disabled = false, className, variant }: CoachButtonProps) => (
  <button
    className={[styles.button, variant && styles[variant], className].filter(Boolean).join(" ")}
    disabled={disabled}
    onClick={(event) => {
      event.preventDefault();
      onClick?.();
    }}
    type={type}
  >
    <span>{children}</span>
    <span className={styles.portraits}>
      {coaches.map((coach) => (
        <img key={coach} className={styles.image} src={coachPortrait(coach)} alt='' />
      ))}
    </span>
  </button>
);
